import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { Fab, Tooltip, Backdrop } from "@material-ui/core";
import { Link, useHistory, Route } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";

import CircularProgress from "@material-ui/core/CircularProgress";
import useStyles from "../../components/Common/styles";
import CurrencyManage from "./currency.manage";
import CurrencyCreate from "./currency.create";
import { useFetchCurrencies } from "../../hooks/useFetchEntities";

function Currencies() {
  const history = useHistory();
  const classes = useStyles();
  const [currencies, fetched] = useFetchCurrencies();

  const [loading, setLoading] = useState(false);

  const onRowClick = (rowData, rowMeta) => {
    history.push("/currencies/manage/" + rowData[0]);
  };

  useEffect(() => {
    setLoading(!fetched);
  }, [fetched]);

  const gridOptions = {
    fixedHeader: true,
    tableBodyMaxHeight: "60vh",
    filterType: "multiselect",
    selectableRows: "none",
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    onRowClick: onRowClick,
    print: false,
    download: false,
  };

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        display: true,
      },
    },
    {
      name: "code",
      label: "Code",
      options: {
        filter: true,
        sort: true,
        display: true,
      },
    },
    {
      name: "symbol",
      label: "Symbol",
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
  ];

  const fabStyle = {
    right: 20,
    position: "fixed",
  };

  return (
    <div style={{ marginRight: 32 }}>
      <Tooltip title="Add" aria-label="add">
        <Fab color="primary" aria-label="add" style={fabStyle} component={Link} to={"/currencies/create"}>
          <AddIcon />
        </Fab>
      </Tooltip>
      {!loading && <MUIDataTable title={"Currencies"} data={currencies} columns={gridColumns} options={gridOptions} />}
      <Route exact path="/currencies/manage/:currencyId">
        <CurrencyManage />
      </Route>
      <Route path="/currencies/create">
        <CurrencyCreate />
      </Route>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="secondary" />
      </Backdrop>
    </div>
  );
}

export default Currencies;
